import { Exception } from 'app/api/exception/Exception';

export enum TRejectCode {
    /**
     * INVALID_PERSONAL_DATA - Ошибка валидации, связанная с заполнением полей заявки. Клиент не может отредактировать данные.
     */
    personalData = 'INVALID_PERSONAL_DATA',

    /**
     * INVALID_BUSINESS_CHECK - Заявка отклонена, если не пройдена хотя бы 1 бизнес-проверка (первичная/вторичная/третичная).
     */
    businessCheck = 'INVALID_BUSINESS_CHECK',

    /**
     * INVALID_SDBO_CHECK - Проверка на наличие ограничений по использованию СДБО провалена
     */
    SDBO = 'INVALID_SDBO_CHECK',
}

/**
 * Ошибка, означающая, что заявка отклонена.
 *
 * Возникает, если при попытке создания/сохранения заявки было определено, что она не может быть подана и
 * дальнейшие действия с ней невозможны.
 */
export class CreditCardOrderRejectedException extends Exception {
    static readonly NAME = 'CreditCardOrderRejectedException';

    constructor(
        id: string,
        type: string,
        message: string,
        rejectedReasons: Array<string>,
        rejectCode: TRejectCode,
    ) {
        super(id, type, message);
        this.name = CreditCardOrderRejectedException.NAME;
        this.rejectReasons = rejectedReasons;
        this.rejectCode = rejectCode;
    }

    /**
     * Список причин отклонения заявки.
     */
    rejectReasons: Array<string>;

    /**
     * Код отклонения заявки
     */
    rejectCode: TRejectCode;
}
